import { TWebsiteImagePack } from "..";
import MethodBuilder from "../method-builder";

class WebsiteImagePackAPI {
  static getAll = new MethodBuilder<void, { data: TWebsiteImagePack[] }>()
    .withName("WebsiteImagePack.getAll")
    .build();

  static import = new MethodBuilder<{ format: "csv"; data: string }, void>()
    .withName("WebsiteImagePack.import")
    .build();

  static export = new MethodBuilder<{ format: "csv" }, { data: string }>()
    .withName("WebsiteImagePack.export")
    .build();
}

export default WebsiteImagePackAPI;
